// File: components/TimesheetTotals.tsx
import { Grid, Typography, Box, useTheme, useMediaQuery } from '@mui/material';

const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export type TimesheetTotalsProps = {
  totalHoursPerDay: (dayIndex: number) => number;
  totalHours: number;
  daysOfWeek: string[];
};
export default function TimesheetTotals({
  totalHoursPerDay,
  totalHours,
}: TimesheetTotalsProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Mobile summary (totals shown in each card, just show grand total)
  if (isMobile) {
    return (
      <Box
        sx={{
          mt: 2,
          p: 2,
          bgcolor: (theme) => theme.palette.custom.primaryTint,
          borderRadius: 2,
          border: '1px solid',
          borderColor: (theme) => theme.palette.custom.primaryTintBorder,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Weekly Total
        </Typography>
        <Typography variant="h4" color="primary" sx={{ fontWeight: 700 }}>
          {totalHours.toFixed(2)} hrs
        </Typography>
      </Box>
    );
  }

  // Desktop layout
  return (
    <Grid
      container
      spacing={1}
      sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 1, mt: 1 }}
      alignItems="center"
    >
      <Grid item xs={3}>
        <Typography fontWeight="bold">Totals</Typography>
      </Grid>
      {daysOfWeek.map((_, i) => (
        <Grid
          item
          xs={1}
          key={i}
          sx={{ textAlign: 'center', fontWeight: 'bold' }}
        >
          {totalHoursPerDay(i).toFixed(2)}
        </Grid>
      ))}
      <Grid item xs={1} sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        {totalHours.toFixed(2)}
      </Grid>
    </Grid>
  );
}
